import {
  FirstPage as FirstPageIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage as LastPageIcon,
} from '@mui/icons-material';
import { IconButton, Theme, useTheme } from '@mui/material';

import { ITableState, TablePaginationActions } from '/shared/Table';

export const AttachmentPaginationActions = <T extends object>({ loading = false }: { loading?: boolean }) => {
  const theme: Theme = useTheme();

  return (state: ITableState<T>) => {
    const { total, page, rowsPerPage, onPageChange } = state;
    const lastPage = Math.ceil(total / rowsPerPage) - 1;

    function handleFirstPageButtonClick() {
      onPageChange(0);
    }

    function handleBackButtonClick() {
      onPageChange(page - 1);
    }

    function handleNextButtonClick() {
      onPageChange(page + 1);
    }

    function handleLastPageButtonClick() {
      onPageChange(Math.max(0, lastPage));
    }

    return (
      <TablePaginationActions>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='First Page' size='large'>
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label='Previous Page' size='large'>
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={(total !== -1 && page >= lastPage) || loading}
          aria-label='Next Page'
          size='large'
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>

        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= lastPage || true}
          aria-label='Last Page'
          size='large'
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </TablePaginationActions>
    );
  };
};
